import styles from './style.module.css';
import axios from 'axios';
import { Markup } from 'interweave';
import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'underscore';
import avatar from '../../assets/images/avatar.png';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { Loading } from '../../components/Loading';
import { Notify } from '../../components/Notify';
import { TextReveal } from '../../components/TextReveal';
import { Input } from '../../components/forms/Input';
import * as routes from '../../constants/Routes';
import { api } from '../../server/api';
import { getYouTubeEmbed } from '../../utils/getYouTubeEmbed';
import { FixedCTA } from './components/FixedCTA';
import { ModalCheckoutEMR } from './components/ModalCheckoutEMR';
import { ModalContact } from './components/ModalContact';
import { ModalLeadExists } from './components/ModalLeadExists';
import { ModalWhatsappIsOpen } from './components/ModalWhatsappIsOpen';
import {
  IAction,
  ICityList,
  IExtraFieldsInputs,
  IFormValues,
  ILead,
  IParams,
  IStateList,
  IHost,
} from './interfaces';
import { IPlayer } from '../../interfaces/IPlayer';
import { IClient } from '../../interfaces/IClient';
import { NotFound } from '../NotFound';
import { InputInternational } from '../../components/forms/InputInternational';
import { toast } from 'react-toastify';
import { WhatsAppCapture } from './components/WhatsAppCapture';
import Rating from '@mui/material/Rating';
import { withStyles } from '@material-ui/core/styles';
import { useRating } from '../../hooks/useRating';

const StyledRating = withStyles({
  iconFilled: {
    color: '#ffc107',
  },
})(Rating);

interface IFormValuesPorteiro {
  patrimonName: string;
  patrimonLastname: string;
  patrimonNumber: string;
  email: string;
  phone: string;
  patrimonType: string;
  patrimonTypeAction: string;
  patrimonCep: string;
  patrimonPrice: string;
  patrimonUnique: boolean;
  patrimonPreferenceNames: object;
  patrimonPreference: boolean;
  patrimonTerms: boolean;
  patrimonPreferenceNameOther: string;
  geoReference: any;
}

export function Action() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<IFormValues>();
  const { getRating, postRating, rating } = useRating();
  const porteiro = useForm<IFormValuesPorteiro>();

  const { actionId, playerId, clientId } = useParams();
  const [player, setPlayer] = useState<IPlayer>();
  const [lead, setLead] = useState<ILead>();
  const [action, setAction] = useState<IAction>();
  const [actionsList, setActionsList] = useState<Array<IAction>>();
  const [client, setClient] = useState<IClient>();
  const [host, setHost] = useState<IHost>();
  const [stateList, setStateList] = useState<Array<IStateList>>();
  const [state, setState] = useState<string>();
  const [cityList, setCityList] = useState<Array<ICityList>>();
  const [city, setCity] = useState<string>();
  const [validationCode, setValidationCode] = useState<string>();
  const [extraField, setExtraField] = useState<any>();
  const [urlCheckout, setUrlCheckout] = useState<string>();
  const [imageGaleryUrl, setImageGaleryUrl] = useState<string>();
  const [messageRegisterLead, setMessageRegisterLead] = useState<any>();
  const [loading, setLoadig] = useState<boolean>(true);
  const [modalWhatsappIsOpen, setModalWhatsappIsOpen] =
    useState<boolean>(false);
  const [contactModalIsOpen, setContactModalIsOpen] = useState<boolean>(false);
  const [modalLeadExistsIsOpen, setModalLeadExistsIsOpen] =
    useState<boolean>(false);
  const [modalCheckoutEMRIsOpen, setModalCheckoutEMRIsOpen] =
    useState<boolean>(false);
  const [isPatrimonPreference, setPatrimonPreference] =
    useState<boolean>(false);
  const [patrimonPreferenceNames, setPatrimonPreferenceNames] = useState([]);
  const [indexActiveTabForm, setindexActiveTabForm] = useState(0);
  const [isBlockAction, setIsBlockAction] = useState(false);
  const [isOpenWhatsAppCapture, setIsOpenWhatsAppCapture] = useState(false);
  const [businessName, setBusinessName] = useState('');

  useEffect(() => {
    const requests = async () => {
      await getActionById({ actionId, playerId, clientId });
      await addPageView();
      await getRating(playerId);

      initReactPixelAndTagManager();
      setLoadig(false);
    };
    requests();

    setTimeout(() => {
      const element = document.getElementById('form-conversion');
      element && element.scrollIntoView();
    }, 8000);
  }, []);

  useEffect(() => {
    if (
      client?.isActiveRegisterStateAndCity &&
      client?.isActiveRegisterStateAndCity === 'true'
    ) {
      getCityList();
    }
  }, [state]);

  useEffect(() => {
    // essa sessão é apagada após o usuário fechar o navegador
    sessionStorage.setItem('playerName', `${player?.name}`);
    sessionStorage.setItem('playerId', `${player?.id}`);
    sessionStorage.setItem('hostId', `${player?.hostId}`);
    sessionStorage.setItem('playerPhoto', `${player?.photoURL}`);

    if (player && !player.active) {
      return navigate(routes.USER_INACTIVE);
    }
  }, [player]);

  useEffect(() => {
    // essa sessão é apagada após o usuário fechar o navegador
    sessionStorage.setItem('clientUrl', `${client?.clientUrl}`);
    sessionStorage.setItem('clientId', `${client?.id}`);
    sessionStorage.setItem('clientLogo', `${client?.logoURL}`);
    sessionStorage.setItem('clientName', `${client?.companyName}`);
  }, [client]);

  useEffect(() => {
    // essa sessão é apagada após o usuário fechar o navegador
    if (player?.hostId) {
      getInvite();
    } else {
      sessionStorage.setItem('actionId', `${action?.id}`);
    }

    const isBlockActionRule =
      action &&
      action?.scope !== 'national' &&
      action?.scopeValues &&
      action?.scopeValues.filter(
        (scope: any) => scope.value === player?.regional
      );

    if (isBlockActionRule && isBlockActionRule.length === 0) {
      setIsBlockAction(true);
    }
  }, [action]);

  useEffect(() => {
    if (
      client?.isActiveRegisterStateAndCity &&
      client?.isActiveRegisterStateAndCity === 'true'
    ) {
      getStateList();
    }

    if (client?.useIntegration === 'enabled') {
      getValidationCode();
    }
  }, [client]);

  useEffect(() => {
    //verifica se o player está ativo
    if (player && !player.active) {
      return navigate(routes.USER_INACTIVE);
    }
  }, [player]);

  const getValidationCode = async () => {
    const parameters = {
      actionId: actionId,
      playerId: playerId,
      clientId: client?.id,
      userType: 'client',
      searchFunctionality: 'validationCode',
    };

    await api
      .post(`/search`, parameters)
      .then((res) => {
        const result = res.data;
        if (result.data[0]) {
          setValidationCode(result.data[0].validationCode);
        }
      })
      .catch((error) => {
        console.log('validationCode error:', error);
      });
  };

  async function getInvite() {
    const actionInvite = await getActionInviteCorrector(
      player?.hostId ? player?.hostId : ''
    );

    sessionStorage.setItem('actionId', `${actionInvite?.id}`);
  }

  const initReactPixelAndTagManager = () => {
    if (client?.clientUrl === 'indiqueeganhe') {
      ReactPixel.init('434785333521291');
    }
    if (client?.clientUrl === 'pride') {
      ReactPixel.init('534566925341849');
    }
    //Pixel facebook Vitta
    if (client?.clientUrl === 'bild') {
      ReactPixel.init('2460474207418199');
      const tagManagerArgs = {
        gtmId: 'G-E81PVE600Y',
      };

      TagManager.initialize(tagManagerArgs);
    }
    //Pixel facebook Credifoz
    if (client?.clientUrl === 'credifoz') {
      ReactPixel.init('1155503887809916');
      ReactPixel.init('334659997143002');
    }
  };

  const getStateList = async () => {
    await axios
      .get('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then((states) => {
        const sortedStates = _.sortBy(states.data, 'nome');
        setStateList(sortedStates);
      })
      .catch((error) => {
        console.log('getStateList error:', error);
      });
  };

  const getCityList = async () => {
    await axios
      .get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`
      )
      .then((city) => {
        const citys = city.data;
        setCityList(citys);
      })
      .catch((error) => {
        console.log('getCityList error:', error);
      });
  };

  const addPageView = async () => {
    const parameters = {
      userType: 'client',
      updateFunctionality: 'addPageViews',
      actionId,
      playerId,
      clientId,
    };

    await api.post(`/update`, parameters);
  };

  const getActionById = async ({ actionId, playerId, clientId }: IParams) => {
    const parameters = {
      searchFunctionality: 'getAction',
      userType: 'consumer',
      actionId,
      playerId,
      clientId,
      capturePage: true,
    };
    try {
      await api.post(`/search`, parameters).then(async (res) => {
        setPlayer(res.data.body.player);
        setAction(res.data.body.action);
        setActionsList(res.data.body.actionsForm);
        setHost(res.data.body.host);
        setClient(res.data.body.client);
      });
    } catch (error) {
      console.log('GetActionById error: ', error);
    }
  };

  const getActionInviteCorrector = async (hostId: string) => {
    try {
      const parameters = {
        searchFunctionality: 'getActionInviteCorrector',
        userType: 'player',
        hostId,
        clientId,
      };

      const { data } = await api.post(`/search`, parameters);
      const actionInvite = data.data;
      return actionInvite;
    } catch (e) {
      console.log('getActionInviteCorrector error', e);
    }
  };

  const getTypeInput = (typeCode: string) => {
    const code = Number(typeCode);

    if (code === 1) {
      return 'text';
    }

    if (code === 2) {
      return 'number';
    }

    if (code === 3) {
      return 'date';
    }

    if (code === 4) {
      return 'select';
    }
  };

  const addPointsToPlayer = async () => {
    const parameters = {
      userType: 'consumer',
      updateFunctionality: 'addActionPoints',
      playerId: playerId,
      pointsNode: 'leadRegistration',
      points:
        action && action.leadRegistration ? Number(action.leadRegistration) : 0,
      actionId,
      clientId,
    };

    const endPoint = `/update`;

    await api.post(endPoint, parameters).catch((error) => {
      console.log('addPointsToPlayer error:', error);
    });
  };

  const addPointsToPlayerStepOne = async (points) => {
    const parameters = {
      userType: 'consumer',
      updateFunctionality: 'addActionPoints',
      playerId: playerId,
      pointsNode: 'advancedStepLead',
      points: points,
      actionId,
      clientId,
    };

    const endPoint = `/update`;

    await api.post(endPoint, parameters).catch((error) => {
      console.log('addPointsToPlayer error:', error);
    });
  };

  const onlyNumbers = (number: string) => {
    return number.replace(/[^\d]+/g, '');
  };

  const openWhatsappModal = () => {
    setModalWhatsappIsOpen(!modalWhatsappIsOpen);
  };

  const renderModalWhatsapp = () => {
    const phoneWhatsapp = onlyNumbers(
      player?.phoneWhatsapp ? player?.phoneWhatsapp : ''
    );
    return (
      <ModalWhatsappIsOpen
        modalIsOpen={modalWhatsappIsOpen}
        toggleModal={openWhatsappModal}
        actionTitle={action?.actionTitle ? action?.actionTitle : ''}
        phoneWhatsapp={phoneWhatsapp}
      />
    );
  };

  const openContactModal = () => {
    setContactModalIsOpen(!contactModalIsOpen);
  };

  const openModalLeadExists = () => {
    setModalLeadExistsIsOpen(!modalLeadExistsIsOpen);
  };

  const renderModalContact = () => {
    let hostId = '';
    if (player.regional === 'nao' && player.hostId) {
      hostId = player.hostId;
    }
    if (player.regional === 'sim') {
      hostId = player.id;
    }
    return (
      <ModalContact
        modalIsOpen={contactModalIsOpen}
        toggleModal={openContactModal}
        clientUrl={client?.clientUrl}
        player={player}
        postRating={(e) => postRating(actionId, lead.id, playerId, Number(e))}
        actionMgm={client?.redirectForPlayer || action?.redirectForPlayer}
        actionMgmCta={
          client?.btnRedirectTextForPlayer || action?.btnRedirectTextForPlayer
        }
        actionMgmRedirect={`${routes.REGISTER}?action=${actionId}&client=${clientId}&player=${hostId}`}
      />
    );
  };

  const openModalCheckoutEMR = () => {
    setModalCheckoutEMRIsOpen(!modalCheckoutEMRIsOpen);
  };

  const renderModalCheckoutEMR = () => {
    return (
      <ModalCheckoutEMR
        modalIsOpen={modalCheckoutEMRIsOpen}
        toggleModal={openModalCheckoutEMR}
        urlCheckout={urlCheckout ? urlCheckout : ''}
      />
    );
  };

  const renderModalLeadExists = () => {
    return (
      <ModalLeadExists
        modalIsOpen={modalLeadExistsIsOpen}
        toggleModal={openModalLeadExists}
        messageRegisterLead={messageRegisterLead}
        player={player}
        client={client}
      />
    );
  };

  const saveLead = async (data: any) => {
    const { name, lastname } = data;
    const fullName = `${name} ${lastname}`;

    if (
      (player && player.email === data.email) ||
      (player && player.cpf === data.cpf)
    ) {
      return Notify('Não é possível haver auto-indicação', 'warn');
    }

    const token =
      Math.random().toString(36).substr(2, 9) +
      Math.random().toString(36).substring(2, 9);

    if (player && player.businessName) {
      setBusinessName(player.businessName);
    }

    const parameters = {
      createFunctionality: 'registerLead',
      userType: 'consumer',
      lead: {
        ...data,
        city: city,
        state: state,
        name: fullName,
        actionId: actionId,
        playerId: playerId,
        clientId: clientId,
        converted: false,
        leadToken: token,
        acceptedTerms: data.acceptedTerms ? 'true' : 'false',
        ...extraField,
        businessName,
      },
      clientId: clientId,
      playerId: playerId,
      validationCode: validationCode,
      urlOrigem: window.location.href,
    };

    await api
      .post('/create', parameters)
      .then(async (res) => {
        const result = res.data;
        const stepOnePoints =
          client &&
          client.steps &&
          client.steps.length > 0 &&
          client.steps[0].value;

        const isActivePointsStepOne = client && client.isActivePointsStepOne;
        setLead(result.data);

        if (result.success) {
          setIsOpenWhatsAppCapture(false);
          if (action?.leadRegistration) {
            await addPointsToPlayer();
          }

          if (isActivePointsStepOne === 'true') {
            await addPointsToPlayerStepOne(stepOnePoints);
          }
          if (client?.redirectUrlLead === 'true') {
            if (client?.clientUrl === 'conectaprev') {
              window.location.href = `${client?.urlRedirect}&name=${
                lead?.name
              }&email=${lead?.email}&cpf=${lead?.cpf.replace(/\D/g, '')}`;
            } else if (client?.clientUrl === 'emr') {
              location.href = `${action?.urlRedirectAction}?src=${player?.id}&utm_term=${result.data.id}&utm_medium=oqdigital`;
            } else {
              openContactModal();
            }
          } else if (
            action?.redirectWhatsapp &&
            action?.redirectWhatsapp === 'true' &&
            player?.phoneWhatsapp &&
            player?.phoneWhatsapp.trim() !== ''
          ) {
            openWhatsappModal();
          } else {
            openContactModal();
          }
        } else {
          if (client?.clientUrl === 'emr') {
            const urlCheckout = `${action?.urlRedirectAction}?src=${player?.id}&utm_term=${result.data.id}&utm_medium=oqdigital`;
            setUrlCheckout(urlCheckout);
            setModalCheckoutEMRIsOpen(!modalCheckoutEMRIsOpen);
          }

          setModalLeadExistsIsOpen(!modalLeadExistsIsOpen);
          setMessageRegisterLead(result.data.message);

          if (client?.redirectUrlLead && client?.redirectUrlLead === 'true') {
            if (client?.clientUrl === 'conectaprev') {
              window.location.href = `${client?.urlRedirect}&name=${
                lead?.name
              }&email=${lead?.email}&cpf=${lead?.cpf.replace(/\D/g, '')}`;
            }
          }
        }
      })
      .catch((error) => console.log('Create lead error: ', error));
  };

  const saveLeadPorteiro = async (data: IFormValuesPorteiro) => {
    const fullName = `${data.patrimonName} ${data.patrimonLastname}`;

    const token =
      Math.random().toString(36).substr(2, 9) +
      Math.random().toString(36).substring(2, 9);

    const parameters = {
      createFunctionality: 'registerLead',
      userType: 'consumer',
      lead: {
        ...data,
        city: city,
        state: state,
        name: fullName,
        actionId: actionId,
        playerId: playerId,
        clientId: clientId,
        converted: false,
        leadToken: token,
        acceptedTerms: data.patrimonTerms ? true : false,
      },
      clientId: clientId,
      playerId: playerId,
      validationCode: validationCode,
      urlOrigem: window.location.href,
    };

    await api
      .post('/create', parameters)
      .then(async (res) => {
        const result = res.data;

        setLead(result.data);

        if (result.success) {
          setIsOpenWhatsAppCapture(false);
          openContactModal();
        } else {
          setModalLeadExistsIsOpen(!modalLeadExistsIsOpen);
        }
      })
      .catch((error) => console.log('SAve lead Porteiro error: ', error));
  };

  const errorSaveLeadPorteiro = (data: any) => {
    if (data.patrimonName) {
      toast.info(data.patrimonName.message);
    }
    if (data.patrimonLastname) {
      toast.info(data.patrimonLastname.message);
    }
    if (data.patrimonEmail) {
      toast.info(data.patrimonEmail.message);
    }
    if (data.patrimonPhone) {
      toast.info(data.patrimonPhone.message);
    }
    if (data.patrimonTypeAction) {
      toast.info(data.patrimonTypeAction.message);
    }
    if (data.patrimonType) {
      toast.info(data.patrimonType.message);
    }
    if (data.patrimonCep) {
      toast.info(data.patrimonCep.message);
    }
    if (data.patrimonPrice) {
      toast.info(data.patrimonPrice.message);
    }
    if (data.patrimonUnique) {
      toast.info(data.patrimonUnique.message);
    }
    if (data.patrimonPreference) {
      toast.info(data.patrimonPreference.message);
    }
    if (data.patrimonTerms) {
      toast.info(data.patrimonTerms.message);
    }
  };

  const slugfy = (str: string) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const maskValue = (value: string): string => {
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return value;
  };

  const maskTel = (value: string): string => {
    value = value.replace(/\D/g, '');
    value = value.replace(/^(\d{2})(\d)/g, '($1) $2');
    value = value.replace(/(\d)(\d{4})$/, '$1-$2');
    return value;
  };

  const onHandlePageTerms = () => {
    navigate(`${routes.TERMS}`, {
      state: { isCameFromActionPage: true, clientId: client?.id },
    });
  };

  const renderFormMGM = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-7">
            <div className="mb-3">
              <Card>
                <div className="d-flex justify-content-center mb-4">
                  <img width="35%" src={client?.logoURL} alt="" />
                </div>
                {action && action.description && (
                  <TextReveal
                    title={action.actionTitle}
                    content={action.description}
                  />
                )}
                <div className="d-grid">
                  <Button
                    text={
                      action && action.membergetmemberCta
                        ? action.membergetmemberCta
                        : 'Cadastre-se aqui'
                    }
                    color="primary"
                    onClick={() =>
                      navigate(
                        `/register?action=${actionId}&client=${clientId}&player=${playerId}&isBusiness=${
                          player && player.isBusiness ? 'true' : 'false'
                        }`
                      )
                    }
                  />
                </div>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-5">{renderCardImages()}</div>
        </div>
      </>
    );
  };

  function extractYoutubeVideoId(url: string) {
    const pattern =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^]+\/.+\?v=|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const result = url.match(pattern);
    return result ? result[1] : null;
  }

  const renderCardImages = () => {
    const videoDefault = `https://www.youtube.com/embed/${extractYoutubeVideoId(
      `${action && action?.videoURL}`
    )}?loop=1&playlist=${extractYoutubeVideoId(
      `${action && action?.videoURL}`
    )}&&autoplay=1&mute=1&controls=0&rel=0&showinfo=0`;

    return (
      <div className="row">
        {/* Primeira imagem em destaque */}
        {action?.images &&
          action.images.length > 0 &&
          action.videoURL === '' && (
            <div className="col-12 mb-3">
              <div className={styles.boxDestackImage}>
                <img src={action.images[0].url} />
              </div>
            </div>
          )}
        {/* fim Primeira imagem em destaque */}

        {/* Video em destaque caso exista */}
        {action?.images &&
          action.images.length > 0 &&
          action.videoURL !== '' && (
            <div className="col-12">
              <div className="container-fluid mb-3 ratio ratio-16x9">
                <iframe className="rounded" src={videoDefault} />
              </div>
            </div>
          )}
        {/* fim Video em destaque caso exista */}

        {/* Demais imagens do grid */}
        {action?.images &&
          action.images.length > 0 &&
          action?.images.map((item, index) => {
            if (index > 0 && action?.images && action?.images.length >= index) {
              return (
                <div key={index} className="col-sm-12 col-md-6 mb-3">
                  <div className={styles.boxDestackImage}>
                    <img src={item.url} />
                  </div>
                </div>
              );
            }
          })}
        {/* fim Demais imagens do grid */}
      </div>
    );
  };

  const renderFormDirect = () => {
    return (
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <div className="mb-3">
            <Card>
              <div className="d-flex justify-content-center mb-4">
                <img width="35%" src={client?.logoURL} alt="" />
              </div>
              {action && action.description && (
                <TextReveal
                  title={action.actionTitle}
                  content={action.description}
                />
              )}
              <div className="d-grid">
                {action?.actionType === 'omnichannel' ? (
                  <Button
                    text="Eu quero"
                    color="primary"
                    onClick={() => window.alert('olha o QR Code...')}
                  />
                ) : (
                  <Button
                    text={`${action?.btnDirectText}`}
                    color="primary"
                    onClick={() =>
                      client?.clientUrl === 'ademicon' &&
                      action?.conversionType === 'direct'
                        ? (location.href = `${location.protocol}//${action.btnDirectRedirectLink}?source=${playerId}&action=${actionId}`)
                        : (location.href = `${action?.btnDirectRedirectLink}`)
                    }
                  />
                )}
              </div>
            </Card>
          </div>
        </div>
        <div className="col-sm-12 col-md-5">{renderCardImages()}</div>
      </div>
    );
  };

  const renderFormLead = () => {
    return (
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <div className="mb-3 me-4">
            {action && action.description && (
              <TextReveal
                title={action.actionTitle}
                content={action.description}
              />
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-5" id="form-conversion">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit(saveLead)();
            }}
          >
            <Card>
              <div className="d-flex justify-content-center mb-2">
                <img width="35%" src={client?.logoURL} alt="" />
              </div>
              <p
                className="fw-semibold text-center mb-4 text-primary-color"
                style={{ fontSize: '16px' }}
              >
                Solicitar contato
              </p>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <div className="mb-3">
                    <Input
                      type="text"
                      {...register('name', {
                        required: true,
                      })}
                      errors={errors.name ? 'Obrigatório' : ''}
                      aria-invalid={errors.name ? 'true' : 'false'}
                      placeholder="Nome"
                    />
                  </div>
                </div>

                <div className="col-sm-12 col-md-6">
                  <div className="mb-3">
                    <Input
                      {...register('lastname', {
                        required: true,
                      })}
                      errors={errors.lastname ? 'Obrigatório' : ''}
                      aria-invalid={errors.lastname ? 'true' : 'false'}
                      type="text"
                      placeholder="Sobrenome"
                    />
                  </div>
                </div>

                {client &&
                  client.customFormLead &&
                  client.customFormLead.cpf &&
                  client.customFormLead.cpf === 'true' && (
                    <div className="col-sm-12 col-md-12">
                      <div className="mb-3">
                        <Input
                          type="text"
                          placeholder="CPF"
                          maxLength={14}
                          errors={errors.cpf ? 'Obrigatório' : ''}
                          {...register('cpf', {
                            required: true,
                            pattern: {
                              value:
                                /([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/i,
                              message: 'CPF inválido.',
                            },
                          })}
                          onChange={(event) => {
                            const { value } = event.target;
                            event.target.value = maskValue(value);
                          }}
                          aria-invalid={errors.cpf ? 'true' : 'false'}
                        />
                      </div>
                    </div>
                  )}

                {client &&
                  client.customFormLead &&
                  client.customFormLead.email &&
                  client.customFormLead.email === 'true' && (
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <Input
                          errors={errors.email ? 'Obrigatório' : ''}
                          {...register('email', {
                            required: true,
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                              message: 'Endereço de e-mail inválido.',
                            },
                          })}
                          aria-invalid={errors.email ? 'true' : 'false'}
                          type="e-mail"
                          placeholder="E-mail"
                        />
                      </div>
                    </div>
                  )}

                {client &&
                  client.customFormLead &&
                  client.customFormLead.phone &&
                  client.customFormLead.phone === 'true' && (
                    <div className="col-sm-12">
                      <div className="mb-3">
                        {client && client.clientUrl !== 'emr' && (
                          <Input
                            prefix="+55"
                            errors={errors.phone ? 'Obrigatório' : ''}
                            {...register('phone', {
                              required: true,
                            })}
                            aria-invalid={errors.phone ? 'true' : 'false'}
                            onChange={(event) => {
                              const { value } = event.target;
                              event.target.value = maskTel(value);
                              const verifyLengthValue = value.replace(
                                /\D/g,
                                ''
                              );

                              if (verifyLengthValue.length > 11) {
                                return Notify(
                                  'Formato de telefone incorreto',
                                  'warn'
                                );
                              }
                            }}
                            type="text"
                            maxLength={15}
                            placeholder="WhatsApp ou Telefone"
                          />
                        )}
                        {client && client.clientUrl === 'emr' && (
                          <>
                            <InputInternational
                              errors={errors}
                              hookForm={register('phone', {
                                required: true,
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                {client &&
                  client.customFormLead &&
                  client.customFormLead.cityAndState &&
                  client.customFormLead.cityAndState === 'true' && (
                    <div className="col-sm-12 col-md-6">
                      <div className="mb-3">
                        <select
                          className={styles.select}
                          name="state"
                          id="state"
                          onChange={(e) => {
                            setState(e.target.value);
                          }}
                        >
                          <option value="">Selecione Estado</option>
                          {stateList &&
                            stateList.length > 0 &&
                            stateList.map((state) => {
                              return (
                                <option key={state.id} value={state.sigla}>
                                  {state?.nome}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  )}

                {client?.customFormLead?.cityAndState === 'true' && (
                  <div className="col-sm-12 col-md-6">
                    <div className="mb-3">
                      <select
                        className={`${styles.select}`}
                        name="city"
                        id="city"
                        onChange={(e) => {
                          setCity(e.target.value);
                        }}
                        value={city ? city : ''}
                      >
                        <option value=""> Selecione Cidade</option>
                        {cityList &&
                          cityList.length > 0 &&
                          cityList.map((city) => {
                            return (
                              <option key={city.id} value={city.nome}>
                                {city?.nome}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                )}

                {action &&
                  action.extraFieldsInputs &&
                  action.extraFieldsInputs.length > 0 && (
                    <>
                      {action.extraFieldsInputs.map(
                        (input: IExtraFieldsInputs, index: number) => (
                          <>
                            {input.type &&
                              getTypeInput(input.type) === 'select' && (
                                <div key={index} className="col-sm-12">
                                  <div className="mb-3">
                                    <label
                                      className="field-label"
                                      htmlFor={input.name && slugfy(input.name)}
                                    >
                                      {input.name}
                                      <code>*</code>
                                    </label>

                                    <select
                                      key={index}
                                      className={`${styles.select}`}
                                      name={input.name && slugfy(input.name)}
                                      required
                                      onChange={(e) => {
                                        setExtraField((prevState: any) => {
                                          return {
                                            ...prevState,
                                            [`${
                                              input.name && slugfy(input.name)
                                            }`]: e.target.value,
                                          };
                                        });
                                      }}
                                    >
                                      <option value="" selected disabled>
                                        Selecione...
                                      </option>
                                      {input.inputOptions &&
                                        input.inputOptions.map((option) => {
                                          return (
                                            <option value={option.name}>
                                              {option.name}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  </div>
                                </div>
                              )}

                            {input.type &&
                              getTypeInput(input.type) !== 'select' && (
                                <div className="col-sm-12">
                                  <div className="mb-3">
                                    <label
                                      className="field-label"
                                      htmlFor={input.name && slugfy(input.name)}
                                    >
                                      {input.name}
                                      <code>*</code>
                                    </label>
                                    <Input
                                      key={index}
                                      {...register(
                                        `${input.name && slugfy(input.name)}`,
                                        {
                                          required: true,
                                        }
                                      )}
                                      type={`${getTypeInput(input.type)}`}
                                      placeholder={input.name}
                                    />
                                  </div>
                                </div>
                              )}
                          </>
                        )
                      )}
                    </>
                  )}

                <div className="d-grid mt-4">
                  <Button
                    text={isSubmitting ? 'Enviando' : 'Enviar'}
                    icon="check_circle"
                    color="primary"
                    type="submit"
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  />
                </div>

                <div className="mt-3">
                  <div className="col-sm-12">
                    <div className="form-check">
                      <input
                        className={`form-check-input ${styles.customBox}`}
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                        {...register('acceptedTerms', {
                          required: true,
                        })}
                      />
                      <label
                        className={`form-check-label fw-normal tiny-text ${styles.customLabelBox}`}
                        htmlFor="flexCheckDefault"
                      >
                        De acordo com as Leis 12.965/2014 e 13.709/2018, que
                        regulam o uso da Internet e o tratamento de dados
                        pessoais no Brasil, ao autorizo{' '}
                        {client?.companyName
                          ? client?.companyName
                          : 'OQ Digital'}{' '}
                        a enviar notificações por e-mail ou outros meios e
                        concordo com sua{' '}
                        <a
                          className="fw-bold tiny-text"
                          target="_blank"
                          href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPoli%CC%81tica%20de%20Privacidade_OQ%20MIDIA%20DIGITAL%20JULHO%202020.docx.pdf?alt=media&token=73c99224-963a-40c8-b385-618bb2cc5122"
                        >
                          Política de Privacidade
                        </a>{' '}
                        e{' '}
                        <a
                          className="fw-bold clickable tiny-text"
                          onClick={onHandlePageTerms}
                        >
                          Termos de uso
                        </a>
                        .
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </form>
        </div>
        <div className={`mt-3 ${styles.pointerImages}`}>
          <div className="d-flex align-items-center">
            <i className="material-icons-outlined me-3 color-text">
              collections
            </i>
            <span className="fs-4 center-text">Mais sobre a indicação</span>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-7">
              {action?.videoURL && action.videoURL !== '' ? (
                <>
                  <div className="my-3">
                    <div className="ratio ratio-16x9">
                      <iframe
                        className="rounded-3"
                        src={getYouTubeEmbed(action.videoURL)}
                      ></iframe>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    {action?.images?.map((image, index) => (
                      <>
                        {index === 0 && (
                          <>
                            <div key={index} className="col-12">
                              <div className="my-3">
                                <img
                                  className="img-fluid ratio ratio-16x9 rounded-3"
                                  src={image.url}
                                  alt=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#galeryView"
                                  onClick={() => {
                                    setImageGaleryUrl(image.url);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="col-sm-12 col-md-5">
              <div className="row">
                {action?.images?.map((image, index) => (
                  <>
                    {index === 0 && action.videoURL === '' ? (
                      <>
                        {index > 0 && (
                          <>
                            <div className="col-sm-12 col-md-6">
                              <div className="my-3">
                                <img
                                  src={image.url}
                                  alt=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#galeryView"
                                  onClick={() => {
                                    setImageGaleryUrl(image.url);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="col-sm-12 col-md-6">
                          <div className="my-3">
                            <div className={styles.boxImageGalery}>
                              <img
                                src={image.url}
                                alt=""
                                data-bs-toggle="modal"
                                data-bs-target="#galeryView"
                                onClick={() => {
                                  setImageGaleryUrl(image.url);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        {actionsList && actionsList.length > 0 && (
          <div className="d-flex align-items-center mb-3">
            <i className="material-icons-outlined me-3 color-text">add</i>
            <span className="fs-4 center-text">
              Indicações de {player && player.name}
            </span>
          </div>
        )}
        <div className="row">
          {actionsList &&
            actionsList.map((actionListitem) => (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="mb-3">
                  <Card>
                    <div className={styles.cardImages}>
                      <img
                        src={
                          actionListitem.images && actionListitem.images[0].url
                        }
                        alt=""
                        className="responsive-img"
                      />
                    </div>
                    <p
                      className="fw-semibold fs-5 mt-3 mb-0 d-inline-block text-truncate w-100"
                      style={{ maxWidth: '100%' }}
                    >
                      {actionListitem.actionTitle}
                    </p>
                    <p
                      className="d-inline-block text-truncate w-100 m-0"
                      style={{ maxWidth: '100%' }}
                    >
                      {<Markup content={actionListitem.description} noHtml />}
                    </p>
                    <div className="mt-3">
                      <div className="d-grid">
                        <Button
                          text="Saiba mais"
                          color="primary"
                          onClick={() => {
                            const uri = location.pathname.split('/');
                            const shareUrl = `${location.protocol}//${location.host}/action/${uri[2]}/${actionListitem.id}/${uri[4]}`;
                            location.href = shareUrl;
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            ))}
        </div>
        {action && action.redirectForPlayer && player && player?.hostId && (
          <div className="row">
            <div className="mt-3" style={{ marginBottom: '65px' }}>
              <div className="col">
                <Card>
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <p className="fw-semibold fs-4">
                        Não tem interesse na indicação?
                      </p>
                      <p>
                        Mas conhece alguém que pode interessar? Faça como{' '}
                        {player && player?.name}: indique a{' '}
                        {client?.companyName} e ganhe prêmios!
                      </p>
                      <a
                        href={`${location.protocol}//${location.host}/register?action=${actionId}&client=${clientId}&player=${player?.hostId}`}
                        target="_blank"
                      >
                        <Button
                          icon="verified"
                          color="primary"
                          text={
                            action && action.btnRedirectTextForPlayer
                              ? action.btnRedirectTextForPlayer
                              : 'Quero ganhar também'
                          }
                        />
                      </a>
                    </div>
                    <div className="col-sm-12 col-md-6"></div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  async function getGeolocation(cep) {
    try {
      const uri = `https://cep.awesomeapi.com.br/json/${cep}`;
      const result = await axios.get(uri);
      porteiro.setValue('geoReference', result.data);
      porteiro.setValue('patrimonNumber', player.patrimonyNumber);
    } catch (e) {
      toast.error(`Cep ${cep} não encontrado`);
      porteiro.setValue('patrimonCep', '');
    }
  }

  const maskDecimal = (v: string): string => {
    if (!v) return '';
    v = v.replace(/\D/g, '');
    v = v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return v;
  };

  const renderFormLeadPorteiro = () => {
    return (
      <div className="row">
        <div className="col-sm-12 col-md-7">
          <div className="mb-3 me-4">
            {action && action.description && (
              <>
                <h1 className="mb-4">{action.actionTitle}</h1>
                <Markup content={action.description} />
              </>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-5" id="form-conversion">
          <form
            onSubmit={porteiro.handleSubmit(
              saveLeadPorteiro,
              errorSaveLeadPorteiro
            )}
          >
            <Card>
              <div className="d-flex justify-content-center mb-2">
                <img width="35%" src={client?.logoURL} alt="" />
              </div>
              <p
                className="fw-semibold text-center mb-4 text-primary-color"
                style={{ fontSize: '16px' }}
              >
                Solicitar contato
              </p>
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className={`nav-link text-black ${
                      indexActiveTabForm === 0 ? 'active' : ''
                    }`}
                    id="nav-home-tab"
                    data-bs-toggle="tab tooltip"
                    data-bs-target="#nav-home"
                    type="button"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    data-bs-placement="top"
                    data-bs-custom-className="custom-tooltip"
                    data-bs-title="This top tooltip is themed via CSS variables."
                    onClick={(e) => {
                      e.preventDefault();
                      setindexActiveTabForm(0);
                    }}
                  >
                    Seus dados
                  </button>
                  <button
                    className={`nav-link ${
                      indexActiveTabForm === 1 ? 'active' : ''
                    } text-black`}
                    id="nav-profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-profile"
                    type="button"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      setindexActiveTabForm(1);
                    }}
                  >
                    Imóvel
                  </button>
                  <button
                    className={`nav-link text-black ${
                      indexActiveTabForm === 2 ? 'active' : ''
                    }`}
                    id="nav-contact-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-contact"
                    type="button"
                    role="tab"
                    aria-controls="nav-contact"
                    aria-selected="false"
                    onClick={(e) => {
                      e.preventDefault();
                      setindexActiveTabForm(2);
                    }}
                  >
                    Preferências
                  </button>
                </div>
              </nav>
              <div className="tab-content py-3" id="nav-tabContent">
                <div
                  className={`tab-pane fade ${
                    indexActiveTabForm === 0 ? 'show active' : ''
                  }`}
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    {/* NOME */}
                    <div className="col-sm-12 col-md-6">
                      <div className="mb-3">
                        <Input
                          type="text"
                          {...porteiro.register('patrimonName', {
                            required: 'Informe seu nome!',
                          })}
                          placeholder="Nome"
                        />
                      </div>
                    </div>

                    {/* SOBRENOME */}
                    <div className="col-sm-12 col-md-6">
                      <div className="mb-3">
                        <Input
                          {...porteiro.register('patrimonLastname', {
                            required: 'Informe seu sobrenome!',
                          })}
                          type="text"
                          placeholder="Sobrenome"
                        />
                      </div>
                    </div>

                    {/* EMAIL */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <Input
                          {...porteiro.register('email', {
                            required: 'Informe seu email!',
                          })}
                          type="email"
                          placeholder="E-mail"
                        />
                      </div>
                    </div>

                    {/* TELEFONE */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <Input
                          prefix="+55"
                          {...porteiro.register('phone', {
                            required: 'Informe seu telefone!',
                          })}
                          onChange={(event) => {
                            const { value } = event.target;
                            event.target.value = maskTel(value);
                            const verifyLengthValue = value.replace(/\D/g, '');

                            if (verifyLengthValue.length > 11) {
                              return Notify(
                                'Formato de telefone incorreto',
                                'warn'
                              );
                            }
                          }}
                          type="text"
                          maxLength={15}
                          placeholder="WhatsApp ou Telefone"
                        />
                      </div>
                    </div>
                    <div className="d-grid mt-4">
                      <a
                        href="#"
                        className="btn bg-primary-color text-white d-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          e.preventDefault();
                          setindexActiveTabForm(1);
                        }}
                      >
                        Próximo
                        <i className="material-icons ms-2">arrow_forward</i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    indexActiveTabForm === 1 ? 'show active' : ''
                  }`}
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    {/* TIPO DE AÇÃO */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <label className="field-label">
                          O que você deseja?
                          <code>*</code>
                        </label>
                        <select
                          className={`${styles.select}`}
                          {...porteiro.register('patrimonTypeAction', {
                            required:
                              'Informe o que você  deseja! (Vender ou alugar)',
                          })}
                        >
                          <option selected disabled value="">
                            Selecione...
                          </option>
                          <option value="Quero VENDER meu imóvel">
                            Quero VENDER meu imóvel
                          </option>
                          <option value="Quero ALUGAR meu imóvel">
                            Quero ALUGAR meu imóvel
                          </option>
                        </select>
                      </div>
                    </div>

                    {/* TIPO DE IMOVEL */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <label className="field-label">
                          Qual tipo de imóvel?
                          <code>*</code>
                        </label>
                        <select
                          className={`${styles.select}`}
                          {...porteiro.register('patrimonType', {
                            required: 'Informe o tipo de imóvel!',
                          })}
                        >
                          <option selected disabled value="">
                            Selecione...
                          </option>
                          <option value="Apartamento">Apartamento</option>
                          <option value="Casa">Casa</option>
                          <option value="Sítio">Sítio</option>
                          <option value="Lote">Lote</option>
                        </select>
                      </div>
                    </div>

                    {/* CEP DO IMOVEL */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <Input
                          {...porteiro.register('patrimonCep', {
                            required: 'Informe o CEP do imóvel',
                          })}
                          type="number"
                          placeholder="CEP do imóvel"
                          onBlur={(e: any) => {
                            if (e.target.value !== '') {
                              getGeolocation(e.target.value);
                            }
                          }}
                        />
                      </div>
                    </div>

                    {/* FAIXA DE PREÇO DO IMOVEL */}
                    <div className="col-sm-12">
                      <div className="mb-3">
                        <Input
                          {...porteiro.register('patrimonPrice', {
                            required: 'Informe o preço do imóvel',
                            onChange: (e) => {
                              const { value } = e.target;
                              porteiro.setValue(
                                'patrimonPrice',
                                maskDecimal(value)
                              );
                            },
                          })}
                          type="text"
                          placeholder="Faixa de preço do imóvel"
                        />
                      </div>
                    </div>

                    <div className="d-grid mt-4">
                      <a
                        href="#"
                        className="btn bg-primary-color text-white d-flex align-items-center justify-content-center"
                        onClick={(e) => {
                          e.preventDefault();
                          setindexActiveTabForm(2);
                        }}
                      >
                        Próximo
                        <i className="material-icons ms-2">arrow_forward</i>
                      </a>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane fade ${
                    indexActiveTabForm === 2 ? 'show active' : ''
                  }`}
                  id="nav-contact"
                  role="tabpanel"
                  aria-labelledby="nav-contact-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    {/* EXCLUSIVIDADE */}
                    <div className="col-12">
                      <p className="fw-semibold tiny-text">
                        Você gostaria de negociar seu imóvel com exclusividade?
                      </p>
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <div className="form-check">
                          <input
                            onChange={() =>
                              porteiro.setValue('patrimonUnique', true)
                            }
                            className="form-check-input"
                            type="radio"
                            id="flexCheckDefault1"
                            name="flexCheckDefault"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault1"
                          >
                            Sim
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            onChange={() => {
                              porteiro.setValue('patrimonUnique', false);
                            }}
                            className="form-check-input"
                            type="radio"
                            id="flexCheckDefault2"
                            name="flexCheckDefault"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault2"
                          >
                            Não
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* PREFERENCIA */}
                    <div className="col-12">
                      <p className="fw-semibold tiny-text">
                        Tem preferência por alguma imobiliária?
                      </p>
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <div className="form-check">
                          <input
                            onChange={() => {
                              setPatrimonPreference(true);
                              porteiro.setValue('patrimonPreference', true);
                            }}
                            className="form-check-input"
                            type="radio"
                            id="flexCheckDefault3"
                            name="flexCheckDefault2"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault3"
                          >
                            Sim
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            onChange={() => {
                              setPatrimonPreference(false);
                              porteiro.setValue('patrimonPreference', false);
                            }}
                            className="form-check-input"
                            type="radio"
                            id="flexCheckDefault4"
                            name="flexCheckDefault2"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckDefault4"
                          >
                            Não
                          </label>
                        </div>
                      </div>
                      {isPatrimonPreference && (
                        <>
                          <p className="fw-semibold tiny-text">Qual(is)?</p>
                          <div className="d-flex align-items-center gap-3 mb-3">
                            <div className="form-check">
                              <input
                                onChange={(e) => {
                                  const data: any = patrimonPreferenceNames;
                                  data[0] = {
                                    label: 'Anuar Donato',
                                    preference: e.target.checked,
                                  };
                                  setPatrimonPreferenceNames(data);
                                  porteiro.setValue(
                                    'patrimonPreferenceNames',
                                    data
                                  );
                                }}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <img
                                src="https://media.licdn.com/dms/image/C4D0BAQH8xszzdBkBCg/company-logo_200_200/0/1630556772388/anuar_donato_consultoria_imobiliria_logo?e=2147483647&v=beta&t=6Fu85BCNhtOAdlvCAs3o5COYnOTIuziyNYElvAbbXUg"
                                alt=""
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div className="form-check">
                              <input
                                onChange={(e) => {
                                  const data: any = patrimonPreferenceNames;
                                  data[1] = {
                                    label: 'Mirian Dayrell',
                                    preference: e.target.checked,
                                  };
                                  setPatrimonPreferenceNames(data);
                                  porteiro.setValue(
                                    'patrimonPreferenceNames',
                                    data
                                  );
                                }}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <img
                                src="https://www.mdimoveis.com.br/assets/img/klm2pewi.png?v=1696352310?v=1710960015"
                                alt=""
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div className="form-check">
                              <input
                                onChange={(e) => {
                                  const data: any = patrimonPreferenceNames;
                                  data[2] = {
                                    label: 'LAR',
                                    preference: e.target.checked,
                                  };
                                  setPatrimonPreferenceNames(data);
                                  porteiro.setValue(
                                    'patrimonPreferenceNames',
                                    data
                                  );
                                }}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <img
                                src="https://iili.io/dhcdCZP.jpg"
                                alt=""
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                            <div className="form-check">
                              <input
                                onChange={(e) => {
                                  const data: any = patrimonPreferenceNames;
                                  data[3] = {
                                    label: 'Decisão',
                                    preference: e.target.checked,
                                  };
                                  setPatrimonPreferenceNames(data);
                                  porteiro.setValue(
                                    'patrimonPreferenceNames',
                                    data
                                  );
                                }}
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                              <img
                                src="https://resizedimgs.vivareal.com/fit-in/100x52/named.images.sp/a469d327bcd99a37ee5ba851b8108c0f/%7Bdescription%7D.webp"
                                alt=""
                                style={{
                                  width: '60px',
                                  height: '60px',
                                  objectFit: 'contain',
                                }}
                              />
                            </div>
                          </div>
                          <Input
                            onChange={(e) =>
                              porteiro.setValue(
                                'patrimonPreferenceNameOther',
                                e.target.value
                              )
                            }
                            type="text"
                            name="patrimonOtherChangeImobiliaria"
                            label="Outra"
                            placeholder="Digite o nome da imobiliária aqui..."
                          />
                        </>
                      )}
                    </div>

                    <div className="mt-5">
                      <div className="col-sm-12">
                        <div className="form-check">
                          <input
                            className={`form-check-input ${styles.customBox}`}
                            type="checkbox"
                            value=""
                            id="flexCheckDefault5"
                            {...porteiro.register('patrimonTerms', {
                              required: 'Aceite os termos!',
                            })}
                          />
                          <label
                            className={`form-check-label fw-normal tiny-text ${styles.customLabelBox}`}
                            htmlFor="flexCheckDefault5"
                          >
                            De acordo com as Leis 12.965/2014 e 13.709/2018, que
                            regulam o uso da Internet e o tratamento de dados
                            pessoais no Brasil, ao autorizo{' '}
                            {client?.companyName
                              ? client?.companyName
                              : 'OQ DIgital'}{' '}
                            a enviar notificações por e-mail ou outros meios e
                            concordo com sua{' '}
                            <a
                              className="fw-bold tiny-text"
                              target="_blank"
                              href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPoli%CC%81tica%20de%20Privacidade_OQ%20MIDIA%20DIGITAL%20JULHO%202020.docx.pdf?alt=media&token=73c99224-963a-40c8-b385-618bb2cc5122"
                            >
                              Política de Privacidade
                            </a>{' '}
                            e{' '}
                            <a
                              className="fw-bold clickable tiny-text"
                              onClick={onHandlePageTerms}
                            >
                              Termos de uso
                            </a>
                            . <br />
                            <br /> Eu autorizo que os meus dados sejam
                            compartilhados com as imobiliárias parceiras do
                            programa tendo ciência que estão em conformidade com
                            a Lei nº 13.709 (Lei Geral de Proteção de Dados -
                            LGPD)
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="d-grid mt-4">
                      <Button
                        text={isSubmitting ? 'Enviando' : 'Enviar'}
                        icon="check_circle"
                        color="primary"
                        type="submit"
                        isLoading={isSubmitting}
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </form>
        </div>
        <div className={`mt-3 ${styles.pointerImages}`}>
          <div className="d-flex align-items-center">
            <i className="material-icons-outlined me-3 color-text">
              collections
            </i>
            <span className="fs-4 center-text">Mais sobre a indicação</span>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-7">
              {action?.videoURL && action.videoURL !== '' ? (
                <>
                  <div className="my-3">
                    <div className="ratio ratio-16x9">
                      <iframe
                        className="rounded-3"
                        src={getYouTubeEmbed(action.videoURL)}
                      ></iframe>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    {action?.images?.map((image, index) => (
                      <>
                        {index === 0 && (
                          <>
                            <div key={index} className="col-12">
                              <div className="my-3">
                                <img
                                  className="img-fluid ratio ratio-16x9 rounded-3"
                                  src={image.url}
                                  alt=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#galeryView"
                                  onClick={() => {
                                    setImageGaleryUrl(image.url);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="col-sm-12 col-md-5">
              <div className="row">
                {action?.images?.map((image, index) => (
                  <>
                    {index === 0 && action.videoURL === '' ? (
                      <>
                        {index > 0 && (
                          <>
                            <div className="col-sm-12 col-md-6">
                              <div className="my-3">
                                <img
                                  src={image.url}
                                  alt=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#galeryView"
                                  onClick={() => {
                                    setImageGaleryUrl(image.url);
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="col-sm-12 col-md-6">
                          <div className="my-3">
                            <div className={styles.boxImageGalery}>
                              <img
                                src={image.url}
                                alt=""
                                data-bs-toggle="modal"
                                data-bs-target="#galeryView"
                                onClick={() => {
                                  setImageGaleryUrl(image.url);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
        {actionsList && actionsList.length > 0 && (
          <div className="d-flex align-items-center mb-3">
            <i className="material-icons-outlined me-3 color-text">add</i>
            <span className="fs-4 center-text">
              Indicações de {player && player.name}
            </span>
          </div>
        )}
        <div className="row">
          {actionsList &&
            actionsList.map((actionListitem) => (
              <div className="col-sm-12 col-md-6 col-xl-4">
                <div className="mb-3">
                  <Card>
                    <div className={styles.cardImages}>
                      <img
                        src={
                          actionListitem.images && actionListitem.images[0].url
                        }
                        alt=""
                        className="responsive-img"
                      />
                    </div>
                    <p
                      className="fw-semibold fs-5 mt-3 mb-0 d-inline-block text-truncate w-100"
                      style={{ maxWidth: '100%' }}
                    >
                      {actionListitem.actionTitle}
                    </p>
                    <p
                      className="d-inline-block text-truncate w-100 m-0"
                      style={{ maxWidth: '100%' }}
                    >
                      {<Markup content={actionListitem.description} noHtml />}
                    </p>
                    <div className="mt-3">
                      <div className="d-grid">
                        <Button
                          text="Saiba mais"
                          color="primary"
                          onClick={() => {
                            const uri = location.pathname.split('/');
                            const shareUrl = `${location.protocol}//${location.host}/action/${uri[2]}/${actionListitem.id}/${uri[4]}`;
                            location.href = shareUrl;
                          }}
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  const renderGaleryAction = () => {
    return (
      <>
        <div
          className="modal fade"
          id="galeryView"
          aria-labelledby="galeryViewLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title fs-5" id="galeryViewLabel">
                  {action?.actionTitle}
                </h2>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <img
                  className="img-fluid ratio ratio-16x9 rounded-3"
                  src={imageGaleryUrl}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (loading) return <Loading />;

  if (client?.clientUrl === 'vivaz' && player?.banned) return <NotFound />;

  return (
    <div className="pageAction" data-bs-theme="light">
      {/* Header action */}
      <HelmetComponent
        actionImages={action?.images}
        actionTitle={action?.actionTitle}
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        playerName={player?.name}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={action?.actionTitle}
        googleAnalyticsIntegration={
          action?.isIntegrationGoogleAnalytics &&
          action.integrationGoogleAnalyticsCode
        }
        pixelIntegration={
          action?.isIntegrationPixel && action.integrationPixelCode
        }
      />

      <FixedCTA
        show={action?.conversionType === 'membergetmember' ? false : true}
        cta={action && action.btnFormText}
      />
      <div className="container">
        <div className="d-flex">
          <div
            className="d-flex align-items-center w-100"
            style={{ height: '68px' }}
          >
            <img src={client && client.logoURL} height="45" alt="" />
          </div>
          <div
            className="d-flex w-100 gap-2 align-items-center justify-content-center bg-primary-color fw-semibold skew"
            style={{ height: '68px' }}
          >
            <span className="fs-5 text-white">
              {client && client.companyName}
            </span>
          </div>
        </div>
        <div className="position-relative" style={{ top: '-25px' }}>
          <div className="d-flex align-items-center justify-content-center">
            <img
              className="rounded-circle fit-cover border border-3 border-white"
              width="75"
              height="75"
              src={player && player.photoURL ? player.photoURL : avatar}
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-center position-relative color-text"
        style={{
          top: '-15px',
          fontSize: '18px',
          fontWeight: '500',
          alignItems: 'center',
          gap: '7px',
        }}
      >
        <StyledRating value={rating?.averageRating} precision={0.1} readOnly />{' '}
        {rating?.averageRating}
      </div>
      <div className="d-flex justify-content-center">
        <div
          className={`${styles.headerText} ${
            (action?.actionTypePerson && action.actionTypePerson === '1') ||
            (action?.actionTypePerson && action?.actionTypePerson === '2')
              ? `${styles.topNone}`
              : ''
          }`}
        >
          {action?.conversionType === 'form' && (
            <h2 className="text-center">
              {action.actionTypePerson && action.actionTypePerson === '0' && (
                <span>
                  <span>{player?.name}</span> tem uma
                  <br />
                  indicação para você
                </span>
              )}

              {((action.actionTypePerson && action.actionTypePerson === '1') ||
                action.actionTypePerson === '2') && (
                <>
                  <div className="container">
                    <div className="d-flex align-items-center flex-column">
                      <div className="mb-5">
                        <img width="200" src={client?.logoURL} alt="" />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </h2>
          )}
          {action?.conversionType === 'membergetmember' && (
            <h2 className="text-center">
              <span>{player?.name}</span> tem um
              <br />
              convite para você
            </h2>
          )}
        </div>
      </div>
      <div className="container">
        <div className="rounded-4 mt-4">
          {action?.images?.map((image, index) => (
            <>
              {index === 0 && (
                <>
                  <img className="image-destack" src={image.url} alt="" />
                </>
              )}
            </>
          ))}
        </div>
      </div>
      {/* fim Header action */}

      {/* Conteúdo da action */}
      <div className={`${styles.content}`}>
        <div className="container">
          <div className="container">
            {isBlockAction && action?.conversionType !== 'membergetmember' && (
              <div className="d-flex justify-content-center">
                <div className="alert alert-primary text-center" role="alert">
                  <h4 className="alert-heading">Ops: link indisponível</h4>
                  <p>
                    Para atualizar seu acesso, por favor, clique no botão
                    abaixo!
                  </p>
                  <hr />
                  <p className="mb-0 text-center">
                    <a
                      href={`${location.protocol}//${location.host}/_/${
                        client && client.clientUrl
                      }`}
                      className="btn btn-primary"
                    >
                      Atualizar link
                    </a>
                  </p>
                </div>
              </div>
            )}
            {action?.conversionType === 'form' &&
              client &&
              client.clientUrl !== 'bomnegocio' &&
              !isBlockAction &&
              renderFormLead()}
            {action?.conversionType === 'form' &&
              client &&
              client.clientUrl === 'bomnegocio' &&
              renderFormLeadPorteiro()}
            {action?.conversionType === 'membergetmember' && renderFormMGM()}
            {((action &&
              action?.btnDirectText &&
              action?.btnDirectRedirectLink &&
              (action.conversionType === 'both' ||
                action.conversionType === 'direct')) ||
              client?.gamificationType === 'goalsLevels') &&
              renderFormDirect()}
            {/* Galeria action */}

            {/* fim Galeria action */}
          </div>
        </div>
      </div>
      {renderGaleryAction()}
      {renderModalWhatsapp()}
      {renderModalContact()}
      {renderModalCheckoutEMR()}
      {renderModalLeadExists()}
      {client &&
        client.isActiveBotWhatsApp === 'true' &&
        action &&
        action.conversionType !== 'membergetmember' && (
          <WhatsAppCapture
            data={(e: any) => {
              saveLead({
                name: e.name,
                lastname: '',
                phone: e.phone,
                email: e.email,
              });
            }}
            isOpen={isOpenWhatsAppCapture}
            client={client}
            player={player}
            host={host}
          />
        )}

      {/* fim Conteúdo da action */}
    </div>
  );
}
